import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Check, X, Lock } from "lucide-react";
import { fullName } from "./shared";

const STATUS = {
  pending: { label: "En attente", cls: "bg-[#FFFBEB] text-[#D97706] border-[#FDE68A]" },
  approved: { label: "Validé", cls: "bg-[#ECFDF5] text-[#059669] border-[#A7F3D0]" },
  rejected: { label: "Refusé", cls: "bg-[#FEF2F2] text-[#E60000] border-[#FECACA]" },
};

export function SiteCongesList({ conges, canDecide, onDecide, lockedHint }) {
  const [comment, setComment] = useState({});
  const pending = conges.filter((c) => c.status === "pending");
  const others = conges.filter((c) => c.status !== "pending").slice(0, 20);

  const Row = ({ c }) => {
    const st = STATUS[c.status] || STATUS.pending;
    return (
      <div className="px-4 py-3 border-b border-[#F1F3F5] last:border-b-0 text-sm" data-testid={`site-conge-${c.id}`}>
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div className="min-w-0">
            <div className="font-semibold">{fullName(c.salarie)} <span className="text-[#868E96] font-normal">· {(c.type || "congé").replace(/_/g, " ")}</span></div>
            <div className="font-mono text-xs text-[#495057]">{c.date_debut} → {c.date_fin}</div>
            {c.motif && <div className="text-xs text-[#868E96] italic mt-0.5">{c.motif}</div>}
          </div>
          <span className={`text-[10px] uppercase tracking-wider font-bold border px-2 py-0.5 ${st.cls}`}>{st.label}</span>
        </div>
        {c.status === "pending" && canDecide && (
          <div className="mt-3 flex gap-2 items-center flex-wrap">
            <Input placeholder="Commentaire (optionnel)" value={comment[c.id] || ""} data-testid={`site-conge-comment-${c.id}`}
                   onChange={(e) => setComment({ ...comment, [c.id]: e.target.value })} className="h-9 flex-1 min-w-[180px]" />
            <Button size="sm" onClick={() => onDecide(c.id, "approved", comment[c.id] || "")} data-testid={`site-conge-approve-${c.id}`}
                    className="h-9 bg-[#059669] hover:bg-[#047857] text-white"><Check className="h-3.5 w-3.5 mr-1" /> Valider</Button>
            <Button size="sm" variant="outline" onClick={() => onDecide(c.id, "rejected", comment[c.id] || "")} data-testid={`site-conge-reject-${c.id}`}
                    className="h-9 border-[#E60000] text-[#E60000] hover:bg-[#E60000] hover:text-white"><X className="h-3.5 w-3.5 mr-1" /> Refuser</Button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="space-y-4" data-testid="site-conges-list">
      {!canDecide && lockedHint && (
        <div className="flex items-center gap-2 text-xs text-[#495057] bg-[#F8F9FA] border border-[#DEE2E6] px-3 py-2" data-testid="site-conges-locked">
          <Lock className="h-3.5 w-3.5 text-[#868E96]" /> {lockedHint}
        </div>
      )}
      <div className="bg-white border border-[#DEE2E6]">
        <div className="px-4 py-2.5 text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] bg-[#F8F9FA] border-b border-[#DEE2E6]">
          À traiter · {pending.length}
        </div>
        {pending.length === 0 ? <div className="p-6 text-center text-sm text-[#868E96]" data-testid="site-conges-empty">Aucune demande en attente.</div>
          : pending.map((c) => <Row key={c.id} c={c} />)}
      </div>
      {others.length > 0 && (
        <div className="bg-white border border-[#DEE2E6]">
          <div className="px-4 py-2.5 text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] bg-[#F8F9FA] border-b border-[#DEE2E6]">Historique récent</div>
          {others.map((c) => <Row key={c.id} c={c} />)}
        </div>
      )}
    </div>
  );
}
